var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldBeVisible)?_c('div',{staticClass:"bar",class:_vm.$config.appEnv},[_vm._v("\n    "+_vm._s(_vm.$config.appEnv.toUpperCase())+"\n")]):(_vm.isForceLogin)?_c('div',{staticClass:"bar forceLogin"},[_vm._v("管理者権限でログイン中です")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }